module.exports = __webpack_public_path__ + "dimer/static/img/DrDX.b8e1830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DrDX.jpg
// module id = 2GHw
// module chunks = 0